import { useState, useEffect } from 'react';
import { fieldValidator, valueFormatter } from '../../utils/yupSchemaCreator';
import { Input, FormControl } from '@airbus/components-react';

export default function FieldNumber(props) {
  const {
    rowId,
    initialValues,
    name,
    label,
    required,
    disabled,
    blurHandler,
    field,
    language,
    handleEnterTabBlur,
  } = props;
  const [value, setValue] = useState(initialValues[name]);
  const [error, setError] = useState(null);
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (initialValues) {
      setValue(initialValues[name]);
      let isTouched = false;
      if (
        initialValues?.isCommitRow ||
        (initialValues?.status === 'E' && initialValues?.backup?.[name] !== initialValues[name]) ||
        ((initialValues?.status === 'N' || initialValues?.status === 'C') &&
          initialValues?.touched[name])
      ) {
        isTouched = true;
      }
      setTouched(isTouched);
      if (isTouched) {
        const error = fieldValidator(field, initialValues[name], language);
        setError(error);
      }
    }
  }, [initialValues]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    const error = fieldValidator(field, newValue, language);
    setError(error);
    if (
      (!error || newValue === '') &&
      !isNaN(+newValue) &&
      (+newValue >= field.attrMinValue || field.attrMinValue === null) &&
      (+newValue <= field.attrMaxValue || field.attrMaxValue === null)
    ) {
      setValue(e.target.value);
    }
  };

  const handleFocus = () => {
    setTouched(true);
  };

  const handleBlur = () => {
    if (initialValues[name] === value) {
      return;
    }
    const result = valueFormatter(value);
    blurHandler(name, result);
    if (field?.onValueChange) {
      field.onValueChange({ rowId, value, row: initialValues });
    }
  };
  return (
    <FormControl
      id={name}
      error={touched && Boolean(error)}
      {...{ label, name, required, disabled }}
      helpText={touched && error?.msg}
      errorText={touched && error?.msg}
      className='disabled-input'
    >
      <Input
        {...{ name }}
        size='small'
        value={value ?? ''}
        readOnly={disabled}
        onChange={(event) => {
          if (isNaN(+event.target.value)) {
            return null;
          }
          handleChange(event);
        }}
        onBlur={handleBlur}
        onFocus={handleFocus}
        onKeyDown={handleEnterTabBlur}
        valid={touched && Boolean(error)}
      />
    </FormControl>
  );
}
